import { useState, useCallback } from 'react';
import { getCurrentTimestamp } from '@zdrbm/zdr-native-tools';
export function useTimestamp() {
    const [timestamp, setTimestamp] = useState(getCurrentTimestamp());
    const setCurrentTimestamp = useCallback(() => {
        setTimestamp(getCurrentTimestamp());
    }, []);
    return { timestamp, setCurrentTimestamp };
}
//# sourceMappingURL=useTimestamp.js.map